import Vue from 'vue';
import Router from 'vue-router';

import {
    frozenShowGuard,
    publicGuard,
    userDataGuard,
} from './guards';
import { modalsHook } from './hooks';
import routes from './routes';

Vue.use(Router);

/**
 * Register router
 */
const router = new Router({
    /**
     * Router mode
     */
    mode: 'history',

    /**
     * Router routes
     */
    routes,

    /**
     * Router scroll parameters
     *
     * @param {object} to Route navigated to.
     *
     * @returns  {object}  Scroll position
     */
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash,
            };
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
});

router.beforeEach(userDataGuard());
router.beforeEach(publicGuard(router));
router.beforeEach(frozenShowGuard);

router.beforeEach(modalsHook);

export default router;
